const card_dict = {
    '001': {
        // Major Arcana
        '001': 'The Fool',
        '002': 'The Magician',
        '003': 'The High Priestess',
        '004': 'The Empress',
        '005': 'The Emperor',
        '006': 'The Hierophant',
        '007': 'The Lovers',
        '008': 'The Chariot',
        '009': 'Strength',
        '010': 'The Hermit',
        '011': 'Wheel of Fortune',
        '012': 'Justice',
        '013': 'The Hanged Man',
        '014': 'Death',
        '015': 'Temperance',
        '016': 'The Devil',
        '017': 'The Tower',
        '018': 'The Star',
        '019': 'The Moon',
        '020': 'The Sun',
        '021': 'Judgement',
        '022': 'The World',
        // Minor Arcana - Wands
        '023': 'Ace of Wands',
        '024': 'Two of Wands',
        '025': 'Three of Wands',
        '026': 'Four of Wands',
        '027': 'Five of Wands',
        '028': 'Six of Wands',
        '029': 'Seven of Wands',
        '030': 'Eight of Wands',
        '031': 'Nine of Wands',
        '032': 'Ten of Wands',
        '033': 'Page of Wands',
        '034': 'Knight of Wands',
        '035': 'Queen of Wands',
        '036': 'King of Wands',
        // Minor Arcana - Cups
        '037': 'Ace of Cups',
        '038': 'Two of Cups',
        '039': 'Three of Cups',
        '040': 'Four of Cups',
        '041': 'Five of Cups',
        '042': 'Six of Cups',
        '043': 'Seven of Cups',
        '044': 'Eight of Cups',
        '045': 'Nine of Cups',
        '046': 'Ten of Cups',
        '047': 'Page of Cups',
        '048': 'Knight of Cups',
        '049': 'Queen of Cups',
        '050': 'King of Cups',
        // Minor Arcana - Swords
        '051': 'Ace of Swords',
        '052': 'Two of Swords',
        '053': 'Three of Swords',
        '054': 'Four of Swords',
        '055': 'Five of Swords',
        '056': 'Six of Swords',
        '057': 'Seven of Swords',
        '058': 'Eight of Swords',
        '059': 'Nine of Swords',
        '060': 'Ten of Swords',
        '061': 'Page of Swords',
        '062': 'Knight of Swords',
        '063': 'Queen of Swords',
        '064': 'King of Swords',
        // Minor Arcana - Pentacles
        '065': 'Ace of Pentacles',
        '066': 'Two of Pentacles',
        '067': 'Three of Pentacles',
        '068': 'Four of Pentacles',
        '069': 'Five of Pentacles',
        '070': 'Six of Pentacles',
        '071': 'Seven of Pentacles',
        '072': 'Eight of Pentacles',
        '073': 'Nine of Pentacles',
        '074': 'Ten of Pentacles',
        '075': 'Page of Pentacles',
        '076': 'Knight of Pentacles',
        '077': 'Queen of Pentacles',
        '078': 'King of Pentacles',
    },
    '002': {
        // I Ching 64 Hexagrams
        '001': '乾',
        '002': '坤',
        '003': '屯',
        '004': '蒙',
        '005': '需',
        '006': '讼',
        '007': '师',
        '008': '比',
        '009': '小畜',
        '010': '履',
        '011': '泰',
        '012': '否',
        '013': '同人',
        '014': '大有',
        '015': '谦',
        '016': '豫',
        '017': '随',
        '018': '蛊',
        '019': '临',
        '020': '观',
        '021': '噬嗑',
        '022': '贲',
        '023': '剥',
        '024': '复',
        '025': '无妄',
        '026': '大畜',
        '027': '颐',
        '028': '大过',
        '029': '坎',
        '030': '离',
        '031': '咸',
        '032': '恒',
        '033': '遁',
        '034': '大壮',
        '035': '晋',
        '036': '明夷',
        '037': '家人',
        '038': '睽',
        '039': '蹇',
        '040': '解',
        '041': '损',
        '042': '益',
        '043': '夬',
        '044': '姤',
        '045': '萃',
        '046': '升',
        '047': '困',
        '048': '井',
        '049': '革',
        '050': '鼎',
        '051': '震',
        '052': '艮',
        '053': '渐',
        '054': '归妹',
        '055': '丰',
        '056': '旅',
        '057': '巽',
        '058': '兑',
        '059': '涣',
        '060': '节',
        '061': '中孚',
        '062': '小过',
        '063': '既济',
        '064': '未济',
    },
}

export default card_dict;